import React, { createContext, useContext, useMemo, useEffect } from 'react';
import { getBrand } from './branding';

const BrandingContext = createContext(null);

export function useBranding() {
  return useContext(BrandingContext);
}

export default function BrandingProvider({ children }) {
  const brand = useMemo(() => getBrand(), []);

  useEffect(() => {
    document.title = brand.name;
  }, [brand.name]);

  return (
    <BrandingContext.Provider value={brand}>
      {children}
    </BrandingContext.Provider>
  );
}
